import connectifService from '../utils/connectifService'
import type { ConnectifProduct } from '../entities'

const sendConnectifPageView = () => {
  import.meta.client && connectifService.send({ type: 'page-visit' })
}

const sendConnectifProductView = (product: ConnectifProduct) => {
  import.meta.client &&
    connectifService.send({
      type: 'product-visited',
      product,
    })
}

export { sendConnectifPageView, sendConnectifProductView }
